function loadImage(images, callback, timeout) {
  // 加载图片的计数器
  var count = 0;
  // 全部图片加载成功的一个标志位
  var success = true;
  // 超时timer的id
  var timeoutId = 0;
  // 是否加载超时的标志位
  var isTimeout = false;
  // 对图片数据或对象进行遍历
  for (var key in images) {
    // 过滤prototype上的属性
    if (!images.hasOwnProperty(key)) {
      continue;
    }
    // 获得每个图片元素
    // 期望格式是个object: {src: xxxx}
    var item = images[key];
    if (typeof item === 'string') {
      item = images[key] = {
        src: item,
      };
    }
    // 如果格式不满足要求，则丢弃，遍历下一条数据
    if (!item || !item.src) {
      continue;
    }

    // 计数器+1
    count++;

    // 设置图片id，保证每次调用id都不同
    item.id = '__img__' + key + getId();
    // 设置图片元素的img，它是一个img对象
    item.img = window[item.id] = new Image();

    doLoad(item);
  }

  // 如果images是一个空数组或空对象，直接执行回调
  if (!count) {
    callback(success);
  } else if (timeout) {
    // 如果用户传递了超时时间
    timeoutId = setTimeout(onTimeout, timeout);
  }

  /**
   * 加载图片
   * @param item
   */
  function doLoad(item) {
    item.status = 'loading';
    var img = item.img;
    // 定义图片加载成功或者失败的回调函数
    img.onload = function() {
      success = success && true;
      item.status = 'loaded';
      done();
    };
    img.onerror = function() {
      success = false;
      item.status = 'error';
      done();
    };
    // 发起一个http的图片请求
    img.src = item.src;

    /**
     * 每张图片加载完成的回调函数
     */
    function done() {
      // 清理事件
      img.onload = img.onerror = null;
      try {
        delete window[item.id];
      } catch (e) {}

      // 每张图片加载完成，计数器减一，当所有图片加载完毕且没有超时的情况下，
      // 清除超时计时器，且执行回调函数
      if (!--count && !isTimeout) {
        clearTimeout(timeoutId);
        callback(success);
      }
    }
  }

  function onTimeout() {
    isTimeout = true;
    callback(false);
  }
}

var __id = 0
function getId() {
  return __id++
}

export default loadImage;



// WEBPACK FOOTER //
// ./utils/preaload.js